export default __webpack_public_path__ + "static/media/c1354ceee6bdfd55d7fa0eb0b139d5241581619797028.3c8ff8fd.webp";